import {useNavigate} from "react-router-dom";
import {ChevronBack} from "@chayka/icons";

type BackButtonProps = {
  onClick?: () => void;
};

export const BackButton = ({onClick}: BackButtonProps) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex items-center justify-center left-6 p-0"
      onClick={onClick ? onClick : () => navigate(-1)}
    >
      <ChevronBack size={30} />
    </div>
  );
};
